import React from "react";

export const Check = ({ color }) => {
  return (
    <svg
      id="check"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 17 17"
    >
      <circle
        id="Ellipse_95"
        data-name="Ellipse 95"
        cx="8.5"
        cy="8.5"
        r="8.5"
        fill={color ? color : "#fff"}
      />
      <g id="check-2" data-name="check" transform="translate(4.001 5.529)">
        <g id="Group_11919" data-name="Group 11919" transform="translate(0 0)">
          <path
            id="Path_225109"
            data-name="Path 225109"
            d="M8.371,71.987a.68.68,0,0,0-.961,0L3.083,76.314,1.16,74.391a.68.68,0,0,0-.962.962l2.4,2.4a.68.68,0,0,0,.962,0l4.808-4.808A.68.68,0,0,0,8.371,71.987Z"
            transform="translate(0.001 -71.788)"
            fill="#17dfba"
            stroke="#FFFFFF"
            stroke-width="1"
          />
        </g>
      </g>
    </svg>
  );
};
